import { Form } from "@/components/core/forms/form.tsx";
import { FormDescription, FormField, FormGroup, FormItem, FormLabel, FormMessage } from "@/components/core/forms/form.tsx";
import userService from "@/features/dashboard/api/services/user-service";
import { useNavigate } from "@tanstack/react-router";
import moment from "moment";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { Button } from "./core/buttons/button";
import { Input } from "./core/forms/input";
import { useModalControl } from "./core/modals/use-modal-controller";

export default function MoveToInformationModal({
	onSubmit,
}: {
	onSubmit: (values: any) => void;
}) {
	const { closeModal } = useModalControl();
	const navigate = useNavigate();
	const [error, setError] = useState(null);
	const form = useForm({
		defaultValues: {
			password: null,
		},
	});

	return (
		<Form {...form}>
			<form className="w-full">
				<div className="grid grid-cols-12 w-full gap-3 py-3">
					<div className="col-span-12 w-full">
						Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minima ducimus non illo dolore, rem suscipit quaerat provident odio quam ratione placeat
						error eveniet voluptates. Consectetur eveniet voluptatum quisquam sint blanditiis.
					</div>
				</div>
				<div className="flex flex-row justify-between w-full gap-4 mt-4">
					<Button
						type="button"
						className=""
						variant="ghost"
						onClick={() => {
							closeModal();
						}}
					>
						Cancel
					</Button>
				</div>
			</form>
		</Form>
	);
}
